const EmptyStock = () => {
  return (
    <div className="card empty-stock" style={{padding: '24px', textAlign: 'center'}}>
      <h3 style={{marginBottom: '8px'}}>종목 정보가 없습니다.</h3>
      <p style={{color: '#666'}}>해당 종목의 정보가 존재하지 않습니다. </p>
    </div>
  )
}

export default EmptyStock;
